import { BodyText } from "@/components/ui/Text";
import type { AiFeedItem } from "@/features/AiFeed/network/types";

interface UnknownItemCardProps {
  item: AiFeedItem;
}

export function UnknownItemCard({ item }: UnknownItemCardProps) {
  return (
    <div className="border-secondary border rounded-lg p-3 bg-secondary opacity-80">
      <BodyText size="sm" bold textColor="tertiary">
        {item.itemType}
      </BodyText>
      <BodyText size="xs" textColor="tertiary" className="mt-0.5">
        This item type is not yet supported in this version.
      </BodyText>
    </div>
  );
}
